'use strict';
const sizes = { small: '120x120', medium: '120x120', big: '505x505', full: '1080x1080' };

const getImageSize = (url, size = 'medium') => {
    const isAkamaizedImage = url?.includes('.akamaized.net') || url?.includes('.cloudfront.net') || url?.includes('apollo.olx.co.id') || url?.includes('apollo-stg.olx.co.id');

    return isAkamaizedImage ? url.concat(';s=').concat(sizes[size]) : url;
};

export {
    getImageSize
};
